function AddSquareIcon() {
  return (
    <span className="anticon anticon-addsqricon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 21 20"
      >
        <path
          stroke="Currentcolor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M7.167 10h6.666M10.5 13.334V6.667M8 18.334h5c4.166 0 5.833-1.667 5.833-5.834v-5c0-4.166-1.666-5.833-5.833-5.833H8c-4.167 0-5.833 1.667-5.833 5.833v5c0 4.167 1.666 5.834 5.833 5.834z"
        />
      </svg>
    </span>
  );
}

export default AddSquareIcon;
